module.exports = __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-4d33231070528d25e0904d2a82bc8c81.ttf";